import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.option = {
      mt: 0,
      pb: 10,
      width: '100%',
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.header = {
      variant: 'flex.row.start.center',
      mt: 10,
      mb: 3,
    };

    this.name = {
      variant: 'text.label.1',
      mr: 4,
    };

    this.selectedOption = {
      color: 'mediumDarkGray',
    };

    this.values = {
      variant: 'flex.row.start',
      flexWrap: 'wrap',
      flexBasis: '100%',
      mr: 'auto',
      gap: 4,
      pl: 0,
    };

    this.value = {
      px: 5,
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      height: '40px',
      minWidth: '64px',
      borderRadius: '44px',
      position: 'relative',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        border: (t) => `1px solid ${t.colors.mediumDarkGray}`,
      },

      available: {
        selected: {
          border: (t) => `1px solid ${t.colors.text}`,
          bg: 'background',
          color: 'text',
        },
        unselected: {
          border: (t) => `1px solid ${t.colors.gray}`,
          bg: 'background',
          color: 'text',
        },
      },

      unavailable: {
        selected: {
          border: (t) => `1px solid ${t.colors.mediumDarkGray}`,
          bg: 'background',
          color: 'mediumDarkGray',
        },
        unselected: {
          border: (t) => `1px solid ${t.colors.gray}`,
          bg: 'background',
          color: 'mediumGray',
        },
      },
    };
  })()
);
